import type { HomeButtonTrackingParams } from '@/app/(home-page)/types';

interface HomeModuleTrackingSource {
  id?: string | number;
  blocks_advances_id?: string | number;
  component_id?: string;
}

interface BuildHomeButtonTrackingParamsOptions {
  indexData: HomeModuleTrackingSource;
  moduleIndex: number;
  moduleTitle?: string;
  buttonName: string;
}

export const buildHomeButtonTrackingParams = ({
  indexData,
  moduleIndex,
  moduleTitle,
  buttonName,
}: BuildHomeButtonTrackingParamsOptions): HomeButtonTrackingParams => ({
  module_index: moduleIndex,
  module_id: String(indexData.blocks_advances_id || indexData.id || ''),
  ...(moduleTitle ? { module_title: moduleTitle } : {}),
  module_name: indexData.component_id || '',
  btn_name: buttonName,
});
